import { TableColumn } from "react-data-table-component";
import { CustomerSessionData } from "../types";

export const baseColumnsDeviceDetailTable: TableColumn<CustomerSessionData>[] = [
  {
    name: "SessionId",
    selector: (row: CustomerSessionData) => row.sessionId,
    width: "400px",
    sortable: true
  },
  {
    name: "SessionProvider",
    selector: (row: CustomerSessionData) => row.sessionProvider,
    width: "250px",
    sortable: true
  },
  {
    name: "Session Created At",
    selector: (row: CustomerSessionData) => new Date(row.sessionCreatedAt).toLocaleString(),
    width: "250px",
    sortable: true
  }
];
